<template>
<div>
  <div v-for="(item, key) in list">
    <p>{{item.title}}</p>
  </div>
  <hrms-infinite-loading @infinite="onInfinite" ref="infiniteLoading">
    <span slot="no-more">
      There is no more Hacker News :(
    </span>
  </hrms-infinite-loading>
</div>
</template>

<script>
const api = 'http://hn.algolia.com/api/v1/search_by_date'

export default {
  data () {
    return {
      list: [],
      tag: 'story'
    }
  },
  methods: {
    onInfinite ($state) {
      this.$http.get(api, {
        params: {
          tags: this.tag,
          page: this.list.length / 20 + 1
        }
      }).then((res) => {
        if (res.data.hits.length) {
          this.list = this.list.concat(res.data.hits)
          $state.loaded()
          if (this.list.length / 20 === 10) {
            $state.complete()
          }
        } else {
          $state.complete()
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?a6c7d4ba